import { render, staticRenderFns } from "./salaryTView.vue?vue&type=template&id=6bcabac2&scoped=true&"
import script from "./salaryTView.vue?vue&type=script&lang=js&"
export * from "./salaryTView.vue?vue&type=script&lang=js&"
import style0 from "./salaryTView.vue?vue&type=style&index=0&id=6bcabac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcabac2",
  null
  
)

export default component.exports